import { render } from "./AppFavoriteHeroes.vue?vue&type=template&id=a9d20db8&scoped=true"
import script from "./AppFavoriteHeroes.vue?vue&type=script&lang=js"
export * from "./AppFavoriteHeroes.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d20db8"]])

export default __exports__